var _div2;
import PropTypes from 'prop-types';
import React from 'react';
import { formatNumber } from '@atc/string-fns';
import { Button, Panel, SideBar, SideBarHeader, Accordion } from 'reaxl';
import FilterCheckboxes from '../FilterCheckboxes';
import FilterPlaceholder from '../FilterPlaceholder';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
function Filters(_ref) {
  var _div, _FilterChipsContainer, _span, _span2;
  let {
    clearFiltersOption = {},
    collapsed,
    collapsedTitle,
    errors = {},
    filterChips: FilterChipsContainer,
    filters = {},
    filtersOrder = [],
    onAccordionClose = () => {},
    onAccordionOpen = () => {},
    onHide = () => {},
    onHideExpansion = () => {},
    onOptionChange = () => {},
    onOptionsClear = () => {},
    onShowExpansion = () => {},
    resultCount,
    saveSearchOption,
    sectionTitle = 'Your Search',
    selectedFilterValues = [],
    show,
    showChips = false,
    showCount = true,
    showSaveSearch = true,
    sortingOption: SortingOption,
    values = {},
    ...rest
  } = _ref;
  const sideBarHeaderAction = /*#__PURE__*/_jsx(Button, {
    bsStyle: "primary",
    className: "pull-right",
    onClick: onHide,
    children: "See Results"
  });
  const sideBarHeader = /*#__PURE__*/_jsx(SideBarHeader, {
    title: "Filters",
    onHide: onHide,
    action: sideBarHeaderAction
  });
  const renderSortingOption = () => {
    if (SortingOption) {
      return _div || (_div = /*#__PURE__*/_jsxs("div", {
        className: "padding-5",
        children: [_div2 || (_div2 = /*#__PURE__*/_jsx("div", {
          className: "padding-bottom-2 text-size-400 text-bold text-gray-base",
          children: "Sort by"
        })), /*#__PURE__*/_jsx(SortingOption, {})]
      }));
    }
    return null;
  };
  const renderFiltersAccordionPanel = (filter, key) => {
    const componentProps = {
      key,
      collapsed,
      collapsedTitle,
      filter,
      filters,
      filtersOrder,
      onOptionChange,
      onOptionsClear,
      resultCount,
      values,
      errors
    };
    let componentClass;
    if (!filter) {
      componentClass = FilterPlaceholder;
    } else if (filter.component) {
      componentClass = filter.component;
    } else {
      // If filter doesn't specify a filter Component class then use FilterCheckboxes
      // If we are using FilterCheckboxes then we should send the onExpansion handlers

      // TODO: This will break if we ever declare FilterCheckboxes as the component class manually
      // but there is an issue with minification changing Class names in prod mode that is making
      // it difficult to determine which filter class we are using
      componentClass = FilterCheckboxes;
      componentProps.onShowExpansion = onShowExpansion;
      componentProps.onHideExpansion = onHideExpansion;
    }
    return /*#__PURE__*/React.createElement(componentClass, componentProps);
  };
  const renderFiltersAccordion = () => {
    const filtersAccordionProps = {
      bsStyle: 'filters',
      defaultActiveKey: [],
      onClose: onAccordionClose,
      onOpen: onAccordionOpen,
      children: [renderSortingOption()]
    };
    let filterKeys = Object.keys(filters);
    if (filtersOrder.length > 0) {
      // Filter supplied keys to ensure we are supplied key to filters that exist or omit
      filterKeys = filtersOrder.filter(filterKey => Object.prototype.hasOwnProperty.call(filters, filterKey));
    }

    // Iterate over filters to build panels and default open array
    filterKeys.forEach(filterKey => {
      const filterObject = filters[filterKey];

      // Determine if Filter Object is actually a map of child filter objects by looking for name property
      const isMultiFilter = !Object.prototype.hasOwnProperty.call(filterObject, 'name');

      // Create collection of filter objects to iterate over to create filter accortion panels
      const filterObjects = isMultiFilter ? Object.keys(filterObject).map(multiFilterKey => filterObject[multiFilterKey]) : [filterObject];
      filterObjects.forEach((filter, index) => {
        if (!filter.collapsed) {
          filtersAccordionProps.defaultActiveKey.push(filter.name);
        }
        const objKey = `${filterKey}-${index}`;
        filtersAccordionProps.children.push(renderFiltersAccordionPanel(filter, objKey));
      });
    });
    return /*#__PURE__*/_jsx(Accordion, {
      ...filtersAccordionProps
    });
  };
  const renderFilterChipsContainer = () => showChips ? _FilterChipsContainer || (_FilterChipsContainer = /*#__PURE__*/_jsx(FilterChipsContainer, {
    selectedFilterValues: selectedFilterValues
  })) : null;
  const renderFilterSelectionContainer = () => /*#__PURE__*/_jsx(Panel, {
    className: collapsed ? 'margin-2' : '',
    children: /*#__PURE__*/_jsxs(Panel.Body, {
      className: "padding-5",
      "data-cmp": "cntnr-fltr-selections",
      children: [/*#__PURE__*/_jsxs("div", {
        className: "display-flex justify-content-between align-items-center",
        children: [_span || (_span = /*#__PURE__*/_jsx("span", {
          className: "text-size-400 text-bold text-gray-base",
          children: sectionTitle
        })), showSaveSearch && (_span2 || (_span2 = /*#__PURE__*/_jsx("span", {
          className: "text-size-md-300 text-size-lg-300 text-right text-bold",
          children: saveSearchOption
        })))]
      }), /*#__PURE__*/_jsx("div", {
        className: "margin-vertical-3",
        children: renderFilterChipsContainer()
      }), showCount && /*#__PURE__*/_jsxs("div", {
        className: "text-size-md-300 text-size-lg-300 text-right",
        children: [`${formatNumber({
          value: resultCount
        })} Results`, clearFiltersOption]
      })]
    })
  });
  const renderSideBar = () => /*#__PURE__*/_jsxs(SideBar, {
    isDocked: false,
    show: show,
    onHide: onHide,
    header: sideBarHeader,
    fullWidth: true,
    children: [showChips && renderFilterSelectionContainer(), /*#__PURE__*/_jsx("div", {
      children: renderFiltersAccordion()
    })]
  });
  const renderColumn = () => /*#__PURE__*/_jsxs(_Fragment, {
    children: [showChips && renderFilterSelectionContainer(), /*#__PURE__*/_jsx(Panel, {
      children: /*#__PURE__*/_jsx(Panel.Body, {
        className: "padding-0",
        children: renderFiltersAccordion()
      })
    })]
  });
  delete rest.filtersOrder;
  delete rest.resultCount;
  return /*#__PURE__*/_jsx("div", {
    "data-cmp": "filters",
    ...rest,
    children: collapsed ? renderSideBar() : renderColumn()
  });
}
export default Filters;